/**
 * DevExtreme (ui/radio_group.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./radio_group/radio_group");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme/ui/radio_group.js
// module id = ../../../../devextreme/ui/radio_group.js
// module chunks = 3